<template>
  <div class="elabel-edit">
    <style-bar :css-keys="['background', 'color']" class="mb-2" mode="text" :styles.sync="localStyles"></style-bar>

    <v-text-field class="text-field mt-2 pt-5 px-2" hide-details placeholder="View u-label data" v-model="form.content" :label="$t('button_text')"></v-text-field>
  </div>
</template>

<script>

import StyleBar from '@/components/utils/StyleBar'

export default {
  name: 'ElabelEdit',
  props: ['content', 'url', 'styles'],
  components: {
    StyleBar
  },
  watch: {
    styles (newVal) {
      this.localStyles = this.styles ? JSON.parse(JSON.stringify(this.styles)) : {}
    }
  },
  data () {
    return {
      form: {
        content: ''
      },
      localStyles: {},
      editorContentJson: {}
    }
  },
  created () {
    this.form.content = this.content
    if (typeof this.form.content !== 'string') {
      this.form.content = ''
    }

    if (this.styles) {
      this.localStyles = JSON.parse(JSON.stringify(this.styles))
    }
  }
}
</script>

<style lang="sass" scoped>

.button-edit
  background: #f1f1f1

.text-field
  background: white

</style>
